import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';
import { BodyText, TextLink, TextSpace, theme } from '@sg/garnish';

export const ForgotToScanFaqLink = (props: ForgotToScanFaqLinkProps) => {
  const { link, onPress } = props;

  const { formatMessage } = useIntl();
  const a11yLabel = formatMessage(messages.faqLinkA11yLabel);

  return (
    <BodyText sizeMatch={['16']} style={styles.text}>
      <BodyText sizeMatch={['16']}>
        <FormattedMessage {...messages.faqLinkPrefix} />
      </BodyText>

      <TextSpace />

      <TextLink
        sizeMatch={['16']}
        href={link}
        accessibilityLabel={a11yLabel}
        style={styles.link}
        onPress={onPress}
      >
        <FormattedMessage {...messages.faqLink} />
      </TextLink>

      <TextSpace />

      <BodyText sizeMatch={['16']}>
        <FormattedMessage {...messages.faqLinkSuffix} />
      </BodyText>
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    textAlign: 'center',
  },
  link: {
    color: theme.colors.SPINACH,
    textAlign: 'center',
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  faqLinkA11yLabel: {
    defaultMessage: 'Open FAQ',
    description: 'Forgot To Scan | FAQ Link | Accessibility Label',
  },
  faqLinkPrefix: {
    defaultMessage: 'See',
    description: 'Forgot To Scan | Landing Page | FAQ',
  },
  faqLink: {
    defaultMessage: 'SG Rewards FAQ',
    description: 'Forgot To Scan | Landing Page | FAQ',
  },
  faqLinkSuffix: {
    defaultMessage: 'to learn more.',
    description: 'Forgot To Scan | Landing Page | FAQ',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ForgotToScanFaqLinkProps = {
  link: string;
  onPress: () => void;
};
